/**
 * Created by Languagenut on 18/04/2019.
 */

 
import React  from 'react';
import { Button, Row, Col, Card} from 'react-bootstrap'
import Translation from '../../../store/internationalization-store.js'

class SelectType extends React.Component {

    constructor(props) {
        super();
        this.props = props;
    }

    componentWillReceiveProps(props){
        this.props = props;
    }

    componentWillMount(){
        
    }

    render(){
        var AdvanceButton2 = React.createElement(Button, {
            onClick: function() {
                this.props.data.homeworkType = "assignment";
                this.props.forceAdvance();
            }.bind(this),
            bsStyle:'primary',
            className:"btn-block"
        },Translation.get(631 , 'Next'));



        var AdvanceButton3 = React.createElement(Button, {
            onClick: function() {
                this.props.data.homeworkType = "template";
                this.props.forceAdvance();
            }.bind(this),
            bsStyle:'primary',
            className:"btn-block"
        },Translation.get(631 , 'Next'));

        return <div>
            <Row><Col md={6}><Card>
                        <Card.Body><Card.Title>{Translation.get(12798, 'Save to Favourites')}</Card.Title>
                        <Card.Text><span style={{height:"50px", display:"block"}}>{Translation.get(12800, "Choosing this function will automatically add this assignment to your favourites library - you can then assign this to your students or classes at a later date.")}</span>
                            {AdvanceButton3}</Card.Text></Card.Body>
                    </Card></Col>
                    <Col md={6}><Card>
                <Card.Body><Card.Title>{Translation.get(12799 , 'Assign to Students')}</Card.Title>
                <Card.Text><span style={{height:"50px", display:"block"}}>{Translation.get(12801, "This will allow you to assign this assignment to your classes or students.")}</span>
                    {AdvanceButton2}</Card.Text></Card.Body>
                </Card></Col>
            </Row></div>;
    }


}


export default {
    name: function() {return Translation.get(336 ,'Save')},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    },
    component: SelectType
}